// Microsoft Clarity's start/stop commands are undocumented (not in
// https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api)
// but are the only mechanism available to scope recording to specific routes
// in a SPA without reloading the tracking script itself.
const ONBOARDING_SHELL_ROUTE_NAMES = [
  'onboarding_shell',
  'onboarding_welcome',
  'onboarding_knowledge_options',
  'onboarding_sandbox',
  'onboarding_channel',
  'onboarding_complete',
];

export const isOnboardingShellRoute = routeName =>
  ONBOARDING_SHELL_ROUTE_NAMES.includes(routeName);

export const syncClarityWithRoute = routeName => {
  if (typeof window.clarity !== 'function') {
    return;
  }

  window.clarity(isOnboardingShellRoute(routeName) ? 'start' : 'stop');
};
